import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import RectangleIcon from '@mui/icons-material/Rectangle';
import * as C from "../map_utils/constants";

function createData(name, value) {
  return { name, value };
}

export default function Summary({ feature }) {
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide border
    '&:td': {
      border: 0,
    },
  }));
  let required_cols = ['id',
    'cshore_consequence_run_id',
    'nsi_identifier',
    'longitude	',
    'latitude',
    'fips_code',
    'occupancy_type',
    'foundation_type',
    'is_shallow',
    'is_single_point_estimation',
    'square_feet',
    'length',
    'foundation_height',
    'ground_elevation',
    'value_structure',
    'val_contents'
  ];
  const rows = [];
  required_cols.forEach(function (item, index) {
    rows.push(createData(item, feature.values_[item]));
  });
  return (
    <TableContainer component={Paper} style={{
      maxWidth: 400, // position: "absolute", top: 70, left: 10,
      backgroundColor: "rgba(255, 255, 255, 1)" // White
    }}>
      <Table aria-label="3D Map Coloring Legend">
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>Info Box</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.name}>
              <TableCell padding="none" style={{ paddingLeft: 10, paddingTop: 5 }} scope="row">{row.name}</TableCell>
              <TableCell padding="none">{row.value}</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}